import { render, staticRenderFns } from "./AddLessonContentModalV2.vue?vue&type=template&id=7074e96c&scoped=true"
import script from "./AddLessonContentModalV2.vue?vue&type=script&lang=js"
export * from "./AddLessonContentModalV2.vue?vue&type=script&lang=js"
import style0 from "./AddLessonContentModalV2.vue?vue&type=style&index=0&id=7074e96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074e96c",
  null
  
)

export default component.exports